import * as React from 'react';

function SvgDollar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 20 20" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx={10} cy={10} fill="#00182E" r={10} />
        <path
          d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm-4.306-5.88l.492-1.094a.545.545 0 01.314-.289.52.52 0 01.424.036c.749.4 1.755.638 2.689.638 1.098 0 1.897-.449 1.897-1.066 0-.4-.232-.88-1.94-1.437-1.85-.581-3.738-1.43-3.738-3.335 0-1.444 1.052-2.574 2.814-3.02l.268-.068V3.29c0-.292.242-.531.535-.531h1.266c.296 0 .535.239.535.531v1.074l.313.039c.753.089 1.42.274 2.033.563a.528.528 0 01.275.304.516.516 0 01-.018.406l-.51 1.08a.541.541 0 01-.485.307.54.54 0 01-.221-.05c-.332-.153-1.11-.506-2.35-.506-1.128 0-1.63.435-1.63.87 0 .485.524.813 2.164 1.355 1.748.57 3.53 1.43 3.53 3.499 0 1.116-.773 2.618-2.956 3.167l-.267.07v1.238a.536.536 0 01-.535.535H9.305a.534.534 0 01-.535-.535v-1.134l-.317-.032c-.984-.11-1.911-.378-2.536-.738a.531.531 0 01-.223-.681z"
          fill="#1ED560"
        />
      </g>
    </svg>
  );
}

export default SvgDollar;
